// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;Though the Lord be high, he watches over the lowly;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;as for the proud, he regards them from afar.<br> </p> </div></div>";
// Exports
module.exports = code;